module.exports = __webpack_public_path__ + "img/pl5_icon.e4a4bb6b.png";